import { harvestYearDetail } from "../../config/harvestYearDetail";
import { userDetail } from "../../config/userDetails";
import { globalApiHandler } from "../../services/services";

export const DASHBOARD = {
  getdashboardinfoList: {
    start: "DASHBOARD_GET_ALL_START",
    success: "DASHBOARD_GET_ALL_SUCCESS",
    error: "DASHBOARD_GET_ALL_ERROR"
  },
  getContractLicenceinfoList: {
    start: "CONTRACT_LICENSE_GET_ALL_START",
    success: "CONTRACT_LICENSE_GET_ALL_SUCCESS",
    error: "CONTRACT_LICENSE_GET_ALL_ERROR"
  },
  getTicketLicenceinfoList: {
    start: "TICKET_LICENSE_GET_ALL_START",
    success: "TICKET_LICENSE_GET_ALL_SUCCESS",
    error: "TICKET_LICENSE_GET_ALL_ERROR"
  },
  getLoginLicenceinfoList: {
    start: "LOGIN_LICENSE_GET_ALL_START",
    success: "LOGIN_LICENSE_GET_ALL_SUCCESS",
    error: "LOGIN_LICENSE_GET_ALL_ERROR"
  },
  getInventoryStatus: {
    start: "GET_INVENTORY_STATUS_START",
    success: "GET_INVENTORY_STATUS_SUCCESS",
    error: "GET_INVENTORY_STATUS_ERROR"
  },
  getCommodityData: {
    start: "GET_COMMODITY_DATA_START",
    success: "GET_COMMODITY_DATA_SUCCESS",
    error: "GET_COMMODITY_DATA_ERROR"
  }
};

export const getDashboardList = () => {
  return (dispatch, getState) => {
    dispatch({ type: DASHBOARD.getdashboardinfoList.start, data: "" });
    const selectedMainFarm = getState().FarmManagementReducer.MainFarmId;
    /* in case of superAdmin no parentFarmId is associated therefore using selectedMainFarm
      from mainFarm Dropdown*/
    let url = `/ntrac/user/stats?farmId=${
      userDetail().parentFarmId ? userDetail().parentFarmId : selectedMainFarm
    }&subFarm=true&harvestYear=${harvestYearDetail().name || "2019"} `;
    globalApiHandler(url, "get", {})
      .then(response => {
        const data = response.data;
        dispatch({ type: DASHBOARD.getdashboardinfoList.success, data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const getContractLicenseList = () => {
  return (dispatch, getState) => {
    dispatch({ type: DASHBOARD.getContractLicenceinfoList.start, data: "" });
    const selectedMainFarm = getState().FarmManagementReducer.MainFarmId;
    let url = `/ntrac/license/${
      userDetail().parentFarmId ? userDetail().parentFarmId : selectedMainFarm
    }/noOfContracts`;
    globalApiHandler(url, "get", {})
      .then(response => {
        const data = response.data;
        dispatch({ type: DASHBOARD.getContractLicenceinfoList.success, data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const getTicketLicenseList = () => {
  return (dispatch, getState) => {
    dispatch({ type: DASHBOARD.getTicketLicenceinfoList.start, data: "" });
    const selectedMainFarm = getState().FarmManagementReducer.MainFarmId;
    let url = `/ntrac/license/${
      userDetail().parentFarmId ? userDetail().parentFarmId : selectedMainFarm
    }/noOfTickets`;
    globalApiHandler(url, "get", {})
      .then(response => {
        const data = response.data;
        dispatch({ type: DASHBOARD.getTicketLicenceinfoList.success, data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const getLoginLicenseList = () => {
  return (dispatch, getState) => {
    dispatch({ type: DASHBOARD.getLoginLicenceinfoList.start, data: "" });
    const selectedMainFarm = getState().FarmManagementReducer.MainFarmId;
    let url = `/ntrac/license/${
      userDetail().parentFarmId ? userDetail().parentFarmId : selectedMainFarm
    }/noOfLogins`;
    globalApiHandler(url, "get", {})
      .then(response => {
        const data = response.data;
        dispatch({ type: DASHBOARD.getLoginLicenceinfoList.success, data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const getInventoryStatus = () => {
  return (dispatch, getState) => {
    dispatch({ type: DASHBOARD.getInventoryStatus.start, data: "" });
    const selectedMainFarm = getState().FarmManagementReducer.MainFarmId;
    let url = `/ntrac/farmOverview/overviewData?farmId=${
      userDetail().parentFarmId ? userDetail().parentFarmId : selectedMainFarm
    }&harvestYearId=${harvestYearDetail().name}`;
    globalApiHandler(url, "get", {})
      .then(response => {
        const data = response.data;
        console.log(data,"inventory Status");
        dispatch({ type: DASHBOARD.getInventoryStatus.success, data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/action.js